import * as React from 'react';

//import ModalDialog from '@mui/joy/ModalDialog';
//import DeleteForever from '@mui/icons-material/DeleteForever';
import { AlertTriangleIcon } from 'lucide-react';
import type { Dispatch } from 'react';
import Card from '@/components/Card';
import Modal from '@mui/material/Modal';
import { Button } from '../Button';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import DialogContent from '@mui/material/DialogContent';
import { useTheme } from '@mui/material';

function AlertDialog({
  title,
  content,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  open,
  setOpen,
  icon = <AlertTriangleIcon />,
  setValue,
  showConfirmButton = true,
  titleColor,
  width = 'auto',
}: {
  title: string;
  content: React.ReactElement;
  confirmText?: string;
  cancelText?: string;
  open: boolean;
  setOpen: Dispatch<React.SetStateAction<boolean>>;
  setValue: Dispatch<React.SetStateAction<boolean>>;
  icon?: React.ReactElement;
  showConfirmButton?: boolean;
  titleColor?: string;
  width?: string;
}) {
  const theme = useTheme();

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        // aplica blur no backdrop
        '& .MuiBackdrop-root': {
          backdropFilter: 'blur(6px)', // intensidade do blur
          backgroundColor: 'rgba(0, 0, 0, 0.4)', // cor + transparência
        },
      }}
    >
      <Card width={width}>
        <DialogTitle
          sx={{
            display: 'flex',
            alignItems: 'flex-end',
            gap: '8px',
            color: titleColor ? titleColor : theme.palette.status.warning,
          }}
        >
          {icon}
          {title}
        </DialogTitle>
        <Divider
          sx={{
            background: theme.palette.fixed.white,
          }}
          orientation="horizontal"
        />
        <DialogContent>{content}</DialogContent>
        <DialogActions
          sx={{ display: 'flex', width: '100%', justifyContent: 'flex-end' }}
        >
          <Button
            variant="primary"
            color="danger"
            onClick={() => {
              setOpen(false);
            }}
          >
            {cancelText}
          </Button>
          {showConfirmButton && (
            <Button
              variant="red"
              color="neutral"
              onClick={() => {
                setOpen(false);
                setValue(true);
              }}
            >
              {confirmText}
            </Button>
          )}
        </DialogActions>
      </Card>
    </Modal>
  );
}

export default AlertDialog;
